var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSearchClear({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_search_clear",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "bounds",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons_clear_search",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding",
    width: 16,
    height: 16,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7200",
    "data-name": "Group 7200",
    transform: "translate(1.936 1.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10903",
    "data-name": "Path 10903",
    d: "M1362.748,330.692l12.128,12.128",
    transform: "translate(-1362.748 -330.692)",
    fill: "none",
    stroke: "#2e65a0",
    strokeLinecap: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10904",
    "data-name": "Path 10904",
    d: "M0,0,12.128,12.128",
    transform: "translate(12.128 0.001) rotate(90)",
    fill: "none",
    stroke: "#2e65a0",
    strokeLinecap: "round",
    strokeWidth: 1.6
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchClear);
export default __webpack_public_path__ + "static/media/icon-search-clear.5970d996.svg";
export { ForwardRef as ReactComponent };